import { useLocalStorage } from "usehooks-ts";
import { DEBUG_MODE_KEY } from "@remi/constants";

import { useKeyboardShortcut } from "./useKeyboardShortcuts";

export const useDebugMode = () => {
  const [debugMode, setDebugMode] = useLocalStorage(DEBUG_MODE_KEY, false);
  useKeyboardShortcut({
    keys: ["control", "shift", "\\"],
    handler: () => {
      setDebugMode((prev) => !prev);
      // biome-ignore lint/suspicious/noConsole: allow console
      console.log(debugMode ? "debug mode activated 🧐" : "debug mode off 🥱");
    },
    name: "Toggle debug mode",
  });
  return debugMode;
};
